module.exports = __webpack_public_path__ + "img/zoom-out.6bfcc868.svg";